import { Store } from "vuex";
import { RootState } from "..";
import { namespace, TermDefinitionReference, term_id } from "../modules/glossary";
export default class Glossary {
    private store: Store<RootState>;

    constructor(store: Store<RootState>) {
        this.store = store;
    }

    public get termsLoaded(): boolean {
        return this.store.getters[`${namespace}/terms`] !== null;
    }

    public get terms(): TermDefinitionReference {
        return this.store.getters[`${namespace}/terms`];
    }

    public getDefinitionAsync(term: term_id): Promise<string> {
        return this.store.dispatch(`${namespace}/getDefinitionAsync`, term);
    }

    public async loadGlossaryAsync() {
        await this.store.dispatch(`${namespace}/loadGlossaryAsync`);
    }
}
